// extracted by mini-css-extract-plugin
export default {"loaderContainer":"Loader_loaderContainer__YvuNt","triangle":"Loader_triangle__u85OM","follow":"Loader_follow__L5FzZ"};